import React from 'react';

const MicrophoneSVG = ({
  className = '',
  color = '#8940FA',
  width = 22,
  height = 25,
}) => (
  <svg width={width} height={height} viewBox="0 0 20 20" className={className}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(6.000000, 2.000000)" fill={color}>
        <g>
          <path d="M8.13675214,4.74074074 C7.87233533,4.74074074 7.65811966,4.9553723 7.65811966,5.22030246 L7.65811966,8.09767275 C7.65811966,9.94855217 6.15516656,11.4546048 4.30769231,11.4546048 C2.46021806,11.4546048 0.957264957,9.94873375 0.957264957,8.09767275 L0.957264957,5.22030246 C0.957264957,4.9553723 0.743049285,4.74074074 0.478632479,4.74074074 C0.214215672,4.74074074 0,4.9553723 0,5.22030246 L0,8.09767275 C0,10.3153506 1.678204,12.1469822 3.82905983,12.3863091 L3.82905983,15.0408766 L2.21464933,15.0408766 C1.95023253,15.0408766 1.73601685,15.2555081 1.73601685,15.5204383 C1.73601685,15.7853684 1.95041376,16 2.21483056,16 L6.40073528,16 C6.66515209,16 6.87936776,15.7853684 6.87936776,15.5204383 C6.87936776,15.2555081 6.66515209,15.0408766 6.40073528,15.0408766 L4.78632479,15.0408766 L4.78632479,12.3863091 C6.93699939,12.1469822 8.61538462,10.3153506 8.61538462,8.09767275 L8.61538462,5.22030246 C8.61538462,4.9553723 8.40098771,4.74074074 8.13675214,4.74074074 Z" />
          <path d="M4.30769231,10.6666667 C5.66504211,10.6666667 6.76923077,9.51173494 6.76923077,8.09200805 L6.76923077,2.57465861 C6.76923077,1.15493172 5.66504211,0 4.30769231,0 C2.95034251,0 1.84615385,1.15493172 1.84615385,2.57465861 L1.84615385,8.09183396 C1.84615385,9.51173494 2.95034251,10.6666667 4.30769231,10.6666667 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default MicrophoneSVG;
